import { usePayResult } from "./PayResult";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { useVerifyEmail } from "@hooks/useVerifyEmail";
import report from "@report";
import { selectRegionName } from "@store/globalSlice";
import { updateRedirectURL, updateShowRefresh, updateSubscribeProducts } from "@store/memberCenterSlice";
import { useOpenWindow } from "@utils/window";
import { useSelector } from "react-redux";
import { useSelectCountryKey } from "@src/jotai/pricing";
import CreditModal from "./CreditModal";
import { LOCALSTORAGE_KEY } from "@config";

export default () => {
  const dispatch = useAppDispatch();
  const { userInfo, language } = useAppSelector((state) => state.globalReducer);
  const pageRegion = "US";
  let regionName = useSelector(selectRegionName);
  const { selectedProducts, redirectURL } = useAppSelector((state) => state.memberCenterReducer);
  const { setVisible, payResult } = usePayResult();
  const { openWindow } = useOpenWindow();
  const { setOpen: setEmailOpen, verifyEmailModal } = useVerifyEmail({});
  const { selectCountryKey } = useSelectCountryKey();

  const goPay = async (promoCode?: string, currentPaymentInfo?: any) => {
    if (!userInfo?.phoneVerified && !userInfo.emailVerified) {
      report.event("phone_unverify", { kalo_pos: "goPay" });
      return setEmailOpen(true);
    }

    if (selectedProducts.length > 0 && selectedProducts[0].quantity > 0) {
      const items = selectedProducts.map((product, index) => {
        return {
          itemId: product.itemId,
          skuId: product.skuId,
          quantity: index === 0 ? product.quantity : product.subQuantity,
        };
      });

      report.click({
        kalo_pos: "GoToPay-" + selectCountryKey,
        kalo_type: selectedProducts[0].key,
      });
      const defaultRedirectURL = window.location.origin + "/video?";
      const params: any = {
        items: items,
        country: regionName,
        redirectUrl: redirectURL || defaultRedirectURL,
        source: currentPaymentInfo?.type,

        // 新增字段， 订阅传递 SUBSCRIPTION 的 单次传递空字符串
        productType: currentPaymentInfo?.canSubscribe ? "SUBSCRIPTION" : "", //"SUBSCRIPTION"
      };

      if (currentPaymentInfo?.type == "onerway") {
        params.source = "onerway";
        params["onerWayParam"] = {
          javaEnabled: window.navigator.javaEnabled(),
          colorDepth: window.screen.colorDepth,
          screenWidth: window.screen.height,
          screenHeight: window.screen.width,
          userAgent: window.navigator.userAgent,
          language: window.navigator.language,
          lpmsType: currentPaymentInfo.key,
          country: pageRegion,
        };
        if (currentPaymentInfo.key === "TrueMoney Wallet") {
          params["onerWayParam"].phone = currentPaymentInfo.phone;
        }
      }

      if (promoCode) {
        params.promotionCode = promoCode;
      }

      const accessToken = localStorage.getItem(LOCALSTORAGE_KEY.ACCESS_TOKEN);
      openWindow(
        `/api/pay/goToPay?token=${accessToken}&param=${encodeURIComponent(JSON.stringify(params))}&language=${language}`,
      );
      dispatch(updateSubscribeProducts([]));
      dispatch(updateRedirectURL(""));
      setVisible(true);
      dispatch(updateShowRefresh(true));
    }
  };

  return (
    <>
      {selectedProducts && selectedProducts.length > 0 && (
        <>{selectedProducts[0].type !== "MEMBER" && <CreditModal goPay={goPay} />}</>
      )}
      {payResult}
      {verifyEmailModal()}
    </>
  );
};
